<div class="main">
    <div class="container">
        <span class="center">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 20 20" fill="#aaa">
            <title>warning</title>
            <path d="M9 8v4c0 0.6 0.4 1 1 1 0.5 0 1-0.4 1-1v-4c0-0.6-0.5-1-1-1-0.6 0-1 0.4-1 1z"></path>
            <path d="M10 15v0c-0.6 0-1 0.4-1 1s0.4 1 1 1v0c0.5 0 1-0.4 1-1s-0.5-1-1-1z"></path>
            <path d="M19.8 17.1l-8-15c-0.4-0.7-1.1-1.1-1.8-1.1s-1.4 0.4-1.8 1.1l-8 15c-0.3 0.6-0.3 1.4 0 2 0.4 0.6 1 1 1.7 1h16c0.7 0 1.4-0.4 1.7-1 0.5-0.7 0.5-1.4 0.2-2zM2 18l8-15 8 15h-16z"></path>
        </svg>
    </span>
        <span class="center">Something went wrong!!</span>

    </div>

</div>